import { render, staticRenderFns } from "./NavigationOutbox.vue?vue&type=template&id=57607280&scoped=true"
import script from "./NavigationOutbox.vue?vue&type=script&lang=js"
export * from "./NavigationOutbox.vue?vue&type=script&lang=js"
import style0 from "./NavigationOutbox.vue?vue&type=style&index=0&id=57607280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57607280",
  null
  
)

export default component.exports